import _ from 'lodash';
import * as t from 'io-ts';
import { createGuard } from 'src_common/common/createGuard';
import { buildSelectionsNewTrading, SelectionNewTradingType } from 'src/components/MarketTemplateSettingsForm/Components/MarketTemplateSelections';
import { MarketTemplateItem } from 'src/components/SportPopup/SportMarketTemplates/SportMarketTemplatesItem';

const MatchingMarketsPartialIO = t.interface({
    type: t.union([ t.literal('Multiple'), t.literal('Single')]),
    marketType: t.union([t.interface({
        type: t.string
    }), t.undefined]),
    matcher: t.union([t.interface({
        type: t.string
    }), t.undefined])
});

type MatchingMarketsPartialType = t.TypeOf<typeof MatchingMarketsPartialIO>;
const isMatchingMarketsGuard = createGuard(MatchingMarketsPartialIO);
export const SourceTypeIO = t.union([
    t.literal('AnyOtherScore'),
    t.literal('AtLeast'),
    t.literal('Away'),
    t.literal('Caught'),
    t.literal('CorrectScoreKey'),
    t.literal('Draw'),
    t.literal('Even'),
    t.literal('Exactly'),
    t.literal('First'),
    t.literal('FlavorlessSelectionKey'),
    t.literal('Home'),
    t.literal('No'),
    t.literal('NoGoal'),
    t.literal('NoScore'),
    t.literal('NoScorerKey'),
    t.literal('Odd'),
    t.literal('Other'),
    t.literal('Over'),
    t.literal('ScorerKey'),
    t.literal('Second'),
    t.literal('Third'),
    t.literal('TimeOfScore'),
    t.literal('Under'),
    t.literal('WinByKnockout'),
    t.literal('WinByPoints'),
    t.literal('Yes')]);

export const isSourceTypeGuard = createGuard(SourceTypeIO);
export type SourceType = t.TypeOf<typeof SourceTypeIO>;
export function getTypeFromNamePattern(namePattern: string): {first: SourceType, second: SourceType} | null {
    const split = namePattern.toLowerCase().split('and');
    const first = split[0]?.replaceAll('$', '').replaceAll('{', '').replaceAll('}', '');


    const second = split[1]?.split(' ')[1];


    if (first === undefined || second === undefined) {
        return null;
    }

    const data = {
        first: _.capitalize(first.trim()),
        second: _.capitalize(second.trim())
    };

    if (isSourceTypeGuard(data.first) === false) {
        console.error('Wrong name pattern');
        return null;
    }
    if (isSourceTypeGuard(data.second) === false) {
        console.error('Wrong name pattern');
        return null;
    }

    //@ts-expect-error
    return data;

}

export function buildMatchingMarkets(data: string): MatchingMarketsPartialType | undefined {
    const rawData = JSON.parse(data);
    if (isMatchingMarketsGuard(rawData)) {
        return rawData;
    }
    console.error('Matching Markets parse error: ', rawData);
}

export function findTypeOfSelection(namePatter: string, type?: string): SelectionNewTradingType['type'] {
    if (namePatter.includes('${player}')) {
        return 'Participant';
    }

    // @ts-expect-error
    return type ?? 'Standard';
}

export function buildNewSelection(template: MarketTemplateItem | undefined, name: string): string {
    if (template === undefined) {
        return '';
    }
    const newTradingSelectionRaw = template.selectionsNewTrading ?? undefined;
    if (newTradingSelectionRaw === undefined) {
        return '';
    }
    const matchingMarket = template?.matchingMarkets ? buildMatchingMarkets(template.matchingMarkets) : undefined;
    const type = findTypeOfSelection(name, matchingMarket?.marketType !== undefined ? matchingMarket.marketType.type : matchingMarket?.matcher?.type);
    if (type === undefined) {
        return '';
    }
    const selections = buildSelectionsNewTrading(newTradingSelectionRaw);
    let newSelection: SelectionNewTradingType | null = null;
    if (type === 'Double') {
        const sourceType: { first: SourceType, second: SourceType } | null = getTypeFromNamePattern(name);
        if (sourceType === null) {
            console.error('Source type is null');
            return '';
        }
        newSelection = {
            type,
            namePattern: name,
            metadata: {},
            autoCreate: true,
            settings: {
                blockSettlement: false,
                feedSettings: {
                    updates: true,
                    prices: true
                }
            },
            first: {
                namePattern: undefined,
                metadata: {},
                sourceType: {
                    type: sourceType.first
                }
            },
            second: {
                namePattern: undefined,
                metadata: {},
                sourceType: {
                    type: sourceType.second
                }
            }
        };
    } else if (type.includes('Line')) {
        newSelection = {
            type: 'Manual',
            namePattern: name,
            metadata: {},
            autoCreate: true,
            settings: {
                blockSettlement: false,
                feedSettings: {
                    updates: true,
                    prices: true
                }
            },
            first: undefined,
            second: undefined
        };
    } else {
        newSelection = {
            type,
            namePattern: name,
            metadata: {},
            autoCreate: true,
            settings: {
                blockSettlement: false,
                feedSettings: {
                    updates: true,
                    prices: true
                }
            },
            first: undefined,
            second: undefined
        };
    }

    if (newSelection !== null) {
        selections?.push(newSelection);
    }

    return JSON.stringify(selections);
}
